/** Bono opcional IA + APP que se suma al costo del curso en la captura de pagos. */
export const COSTO_BONO_IA_APP = 299

const IVA = 0.16

export default {
  data: () => ({
    bonoIaApp: 0,
  }),

  computed: {
    costoBonoIaApp () {
      return COSTO_BONO_IA_APP
    },

    montoBonoIaApp () {
      return this.bonoIaApp ? COSTO_BONO_IA_APP : 0
    },

    ivaBonoIaApp () {
      if ( !this.bonoIaApp || !this.solcitaFactura ) return 0
      return parseFloat( ( COSTO_BONO_IA_APP * IVA ).toFixed( 2 ) )
    },

    /** Lo que el bono agrega al total a pagar ( bono + su IVA cuando se factura ). */
    totalBonoIaApp () {
      return parseFloat( ( this.montoBonoIaApp + this.ivaBonoIaApp ).toFixed( 2 ) )
    },

    /** IVA del curso más el IVA del bono, para mostrar un solo renglón en el desglose. */
    ivaConBonoIaApp () {
      const ivaCurso = parseFloat( this.total_a_pagar ) * IVA
      if ( !Number.isFinite( ivaCurso ) ) return this.ivaBonoIaApp
      return parseFloat( ( ivaCurso + this.ivaBonoIaApp ).toFixed( 2 ) )
    },
  },

  methods: {
    /** Campos del bono que viajan al backend para guardar y para el recibo. */
    payloadBonoIaApp () {
      return {
        bono_ia_app_sn    : this.bonoIaApp ? 1 : 0,
        bono_ia_app_monto : this.montoBonoIaApp,
        bono_ia_app_iva   : this.ivaBonoIaApp,
      }
    },

    /**
     * Deja el check marcado si el cálculo de precio indica que el bono
     * ya estaba registrado en un pago anterior.
     */
    aplicarBonoIaAppDesdeRespuesta ( data ) {
      if ( data && Number( data.bono_ia_app_sn ) ) {
        this.bonoIaApp = 1
      }
    },
  },
}
